import React from "react";
import PropTypes from "prop-types";
import { MemoryRouter, Route, Routes } from "react-router-dom";
import { StateMachineProvider, createStore } from "little-state-machine";
import defaultStoreData from "../lib/store/defaultStoreData";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import DoneOutline from "@mui/icons-material/DoneOutline";
import MemoryStorage from "../lib/store/memoryStorage";

function buildPath(key) {
  let path = "/";
  if (key > 0) {
    path += key;
  }
  return path;
}

function Stepper({ steps, result, storageName }) {
  const statusSteps = steps.map(() => false);
  createStore(
    { ...defaultStoreData, statusSteps },
    { name: `__LSM__${storageName}`, storageType: MemoryStorage }
  );
  const routes = steps.map((step, key) => {
    return (
      <Route key={`route${key}`} exact path={buildPath(key)} element={step} />
    );
  });
  const entries = steps.map((step, key) => buildPath(key));
  return (
    <StateMachineProvider>
      <MemoryRouter initialEntries={entries} initialIndex={0}>
        <Routes>
          {routes}
          <Route exact path="/result" element={result} />
        </Routes>
      </MemoryRouter>
    </StateMachineProvider>
  );
}

Stepper.defaultProps = {
  result: (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Merci pour votre demande
          </Typography>
          <Typography variant="subtitle1">
            Votre demande a bien été prise en compte. Nous la transmettons à nos
            partenaires.
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} justify="center">
        <Box p="2rem">
          <DoneOutline color="primary" style={{ fontSize: 100 }} />
        </Box>
      </Grid>
    </React.Fragment>
  ),
  storageName: "default",
};

Stepper.propTypes = {
  /**
   * Collection de React.Fragment contenant les étapes du formulaire
   */
  steps: PropTypes.arrayOf(PropTypes.element).isRequired,
  /**
   * Composant React d'affichage de la page de validation
   */
  result: PropTypes.element.isRequired,
  /**
   * Nom du stockage des résultats du formulaire
   */
  storageName: PropTypes.string,
};

export default Stepper;
